import React, { FC, ReactNode } from "react";
import imagePng from "images/hero-right2.png";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import HeroSearchForm, {
  SearchTab,
} from "components/HeroSearchForm/HeroSearchForm";
import { RootState } from "redux/store";
import { useSelector } from "react-redux";
import StaySearchForm from "components/HeroSearchForm/(stay-search-form)/StaySearchForm";

export interface SectionHeroArchivePageProps {
  className?: string;
  listingType?: ReactNode;
  currentPage: "Stays" | "Experiences" | "Cars" | "Flights";
  currentTab: SearchTab;
  rightImage?: string;
}

const SectionHeroArchivePage: FC<SectionHeroArchivePageProps> = ({
  className = "",
  listingType,
  rightImage = imagePng,
}) => {
  const storedSearchData = useSelector(
    (state: RootState) => state.search.searchedData
  );
  const { label, searchedResult } = storedSearchData;
  const propertiesCount = searchedResult?.meta?.total_count;
  const city = storedSearchData?.locationData?.city;
  const address = [
    storedSearchData?.locationData?.city,
    storedSearchData?.locationData?.country,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <div
      className={`nc-SectionHeroArchivePage flex flex-col relative ${className}`}
      data-nc-id="SectionHeroArchivePage"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-6 lg:space-y-10 pb-14 lg:pb-64 xl:pb-80 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-medium text-4xl md:text-5xl xl:text-5xl leading-[110%]">
            {label || address || "No Property Available"}
          </h2>
          <div className="flex items-center text-base md:text-lg text-neutral-500 dark:text-neutral-400">
            <span className="ml-2.5">
              {city ? city : "No Property Available"}
            </span>

            <span className="mx-5"></span>

            {listingType ? (
              <span className="mx-5">{listingType}</span>
            ) : (
              propertiesCount > 0 && (
                <div className="flex items-center">
                  <i className="text-2xl las la-home"></i>
                  <span className="ml-2.5">{propertiesCount} properties</span>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex-grow">
          <img className="w-full" src={rightImage} alt="hero" />
        </div>
      </div>
      <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <div className="nc-HeroSearchForm w-full max-w-6xl py-5 lg:py-0">
          <StaySearchForm screenType="searchInside" />
        </div>
      </div>
    </div>
  );
};

export default SectionHeroArchivePage;
